import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useMemo,
} from 'react';
import { useAuth } from '../../hooks/auth';
import { Container, Table } from './styles';
import RowSimpleGrouped from '../RowSimpleGrouped/index';
import ColumnSimpleGrouped from '../ColumnSimpleGrouped';
import Swal from 'sweetalert2';
import {
  AiOutlineDelete,
  AiFillCloseCircle,
  AiFillFileWord,
  AiFillFilePdf,
  AiFillFileExcel,
  AiFillFileImage,
} from 'react-icons/ai';
import { FaFileAlt } from 'react-icons/fa';
import GuideExternalLink from '../GuideExternalLink';
import Api, { exceptionNotificationAPI } from '../../services/api';
import Collapse from 'react-bootstrap/Collapse';
import TooltipComponent from '../TooltipComponent';
import { CommentTextArea } from './styles';
import ChatButton from '../ChatButton/index';
import useScrollOnDrag from 'react-scroll-ondrag';
import { FaAngleDown, FaAngleUp, FaExternalLinkAlt } from 'react-icons/fa';
import EvidenceButton from '../EvidenceButton';
import GetTypeInput from '../FormInput/set';
import {
  removeFile,
  computeRowModeValueColumnWidths,
  getRowModeValueTdWidthStyle,
  getLiveEvidenceRefValidateValue,
} from '../../services/functions';

/**
 * Largura mínima por coluna de valor na tabela agrupada (scroll horizontal).
 * O select mantém largura fixa na célula (100%) e só cresce na vertical com quebra de linha do texto.
 */
const GROUPED_TABLE_VALUE_CELL_MIN_PX = 80;
// Multi-selects precisam comportar os chips/placeholder (control com minWidth 200px)
// e ainda a seta de comentário/arquivo ao lado, sem invadir a célula seguinte.
const GROUPED_TABLE_MULTI_SELECT_CELL_MIN_PX = 280;
/** Monta dynamicBlockKpis a partir das regras cruas da API (refNumber por subSectionKPIID quando falta no bloco). */
function buildDynamicBlockKpisFromConditionalRules(moduleObject, subSectionKPIs) {
  const rules = moduleObject?.data?.subSectionKPIConditionalBlockRules;
  if (!rules?.length || !subSectionKPIs?.length) return null;

  const dynamicBlockKpisNew = {};
  rules.forEach(rule => {
    const refNumbersToBlock = (rule.subSectionKPIConditionalBlocks || [])
      .map(block => {
        const r = block?.refNumber ?? block?.RefNumber;
        if (r != null && r !== '') return r;
        const id = block?.subSectionKPIID ?? block?.SubSectionKPIID;
        if (id != null) {
          const ssk = subSectionKPIs.find(x => x.subSectionKPIID == id);
          return ssk?.refNumber ?? null;
        }
        return null;
      })
      .filter(r => r != null && r !== '');

    if (!dynamicBlockKpisNew[rule.refNumber]) {
      dynamicBlockKpisNew[rule.refNumber] = [
        { answerToBlock: rule.value, refNumbersToBlock },
      ];
    } else {
      dynamicBlockKpisNew[rule.refNumber].push({
        answerToBlock: rule.value,
        refNumbersToBlock,
      });
    }
  });
  return dynamicBlockKpisNew;
}

const GroupedByColumnRowTable = ({
  calculations,
  subSection,
  subSectionGroupColumnInfo,
  moduleObject,
  setModuleObject,
  toleranceValidations,
  formatValuesInTooltip,
  setNumber,
  setText,
  funcCollapse,
  collapse,
  collapseText,
  collapseRow,
  collapseCol,
  defaultChatRequest,
  setComment,
  uploadFile,
  getFile,
  blockedField,
  totalColumns,
  MODULE_ID,
  setChatRequest,
  setShowChat,
  chatRequest,
  kpiDiscussions,
  kpiEvidences,
  setKPIEvidences,
  defaultValues,
  subSectionKPIsToBlock,
  loading,
  subSectionKPIs,
  changeSelectedCultureType,
  changeSelectedCountry,
  changeSelectedFuelType,
  changeSelectedCultureTypeRow,
  selectedCultureTypes,
  selectedFuelTypes,
  selectedCultureTypesRow,
  selectedCountries,
  selectedCuringBarns,
  cultureTypeID = null,
  updateSelectedFuelType,
  updateSelectedCountry,
  loadRefNumbersAndCalculations,
  rejectedKpisList,
  setRejectedKpisList,
  fixedKpisList,
  changeSelectedCuringBarn,
  updateSelectedCuringBarn,
  setEvidenceRequest,
  setShowUploadEvidence,
  evidenceRequest,
  defaultEvidenceRequest,
  setSubsectionKPIs,
  userRoles
}) => {
  const ref = useRef();
  const tableViewportRef = useRef(null);
  const tableElementRef = useRef(null);
  const { events } = useScrollOnDrag(ref);
  const [numberOfRows, setNumberOfRows] = useState();
  const [descriptionColumnsWidth, setDescriptionColumnsWidth] = useState();
  const [valueColumnsWidth, setValueColumnsWidth] = useState();
  const [selectedSSK, setSelectedSSK] = useState();
  const [showDescriptionColumn, setShowDescriptionColumn] = useState(true);
  const [showUnitColumn, setShowUnitColumn] = useState(true);
  const [showSecondaryUnitsColumn, setShowSecondaryUnitsColumn] =
    useState(false);
  const [isRowOrColumn, setIsRowOrColumn] = useState(false);
  const [kpiColumns, setkpiColumns] = useState([]);
  const [isColumnOverload, setisColumnOverload] = useState(
    subSection.columnRows.length >= 10,
  );
  const [hasHorizontalOverflow, setHasHorizontalOverflow] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [userObject, setUserObject] = useState(
    JSON.parse(localStorage.getItem('@Thrive:user')),
  );
  //Column Types
  const COLUMN_ROW_TYPES = {
    Simple: 1,
    Country: 2,
    FuelType: 3,
    CultureType: 4,
    Year: 5,
  };

  const moduleObjectForColumnLayout = useMemo(() => {
    const rebuilt = buildDynamicBlockKpisFromConditionalRules(
      moduleObject,
      subSectionKPIs,
    );
    if (rebuilt && Object.keys(rebuilt).length > 0) {
      return { ...moduleObject, dynamicBlockKpis: rebuilt };
    }
    return moduleObject;
  }, [moduleObject, subSectionKPIs]);

  var List = [];

  useEffect(() => {
    var totalColumns = 0;
    subSection.columnRows.map(e => {
      if (e.minimumQuantity) {
        totalColumns += e.minimumQuantity;
      } else {
        totalColumns += 1;
      }
    });

    var columnsCount = subSection.columnRows.length;
    if (subSection.isColumnRow == false) {
      if (columnsCount == 1 && subSection.columnRows[0].minimumQuantity > 0) {
        setDescriptionColumnsWidth(10);
        setValueColumnsWidth(20);
      } else if (columnsCount == 2) {
        setDescriptionColumnsWidth(15);
        setValueColumnsWidth(20);
      } else if (columnsCount > 2 && columnsCount <= 5) {
        setDescriptionColumnsWidth(40);
        setValueColumnsWidth(10);
      } else if (columnsCount > 5 && columnsCount <= 12) {
        setDescriptionColumnsWidth(10);
        setValueColumnsWidth(20);
      } else {
        setDescriptionColumnsWidth(20);
        setValueColumnsWidth(20);
      }
    } else {
      var columnsize = Math.round((96 / columnsCount) * 100) / 100;
      setDescriptionColumnsWidth(0);
      setValueColumnsWidth(columnsize);

      if (columnsCount == 2) {
        setDescriptionColumnsWidth(30);
        setValueColumnsWidth(20);
      }
      // else if (columnsCount > 2 && columnsCount <= 5) {
      //     setDescriptionColumnsWidth(0);
      //     setValueColumnsWidth(20);
      // }
      // else if (columnsCount > 5) {
      //     setDescriptionColumnsWidth(0);
      //     setValueColumnsWidth(15);
      // }
      // else {
      //     setDescriptionColumnsWidth(0);
      //     setValueColumnsWidth(10);
      // }
    }

    setIsRowOrColumn(subSection.isColumnRow);
    setNumberOfRows(subSection.numberOfRows);
  }, []);

  const reordenateColumns = columns => {
    var columnsSorted = columns.sort((a, b) =>
      a.columnRowOrder > b.columnRowOrder ? 1 : -1,
    );
    return columnsSorted;
  };

  /** Alinha larguras do thead com RowSimpleGrouped (selects/listas largas vs numéricos). */
  const rowModeHeaderValueLayout = useMemo(() => {
    if (!isRowOrColumn || !subSection?.kpis?.[0]) {
      return {
        hasWide: false,
        uniformPercent: valueColumnsWidth,
        widePercent: 70,
        narrowPercent: null,
      };
    }
    return computeRowModeValueColumnWidths(
      subSection.kpis[0],
      subSectionKPIs,
      subSection.columnRows,
      reordenateColumns,
      valueColumnsWidth,
      70,
    );
  }, [isRowOrColumn, subSection, subSectionKPIs, valueColumnsWidth]);

  const valueColumnCellCount = useMemo(() => {
    const rows = subSection?.columnRows;
    if (!rows?.length) return 0;
    const sorted = [...rows]
      .filter(x => !x.isParentColumn)
      .sort((a, b) => (a.columnRowOrder > b.columnRowOrder ? 1 : -1));
    return sorted.reduce((acc, cr) => {
      const q =
        cr.minimumQuantity != null && cr.minimumQuantity > 1
          ? cr.minimumQuantity
          : 1;
      return acc + q;
    }, 0);
  }, [subSection?.columnRows]);

  /**
   * No layout por colunas, cada KPI é uma linha. Por isso a largura precisa ser
   * calculada por ColumnRow usando todos os KPIs da subsection, e não apenas o
   * primeiro deles. Campos comuns continuam compactos; multi-selects ganham
   * espaço suficiente e a tabela passa a usar o scroll horizontal existente.
   */
  const valueCellMinWidthByColumnRowID = useMemo(() => {
    const widths = {};
    (subSection?.columnRows || [])
      .filter(columnRow => !columnRow.isParentColumn)
      .forEach(columnRow => {
        const hasMultiSelect = (subSectionKPIs || []).some(
          sskpi =>
            sskpi.columnRowID == columnRow.columnRowID &&
            sskpi.unitMeasure?.inputType === 'multiselectcustom',
        );
        widths[columnRow.columnRowID] = hasMultiSelect
          ? GROUPED_TABLE_MULTI_SELECT_CELL_MIN_PX
          : GROUPED_TABLE_VALUE_CELL_MIN_PX;
      });
    return widths;
  }, [subSection?.columnRows, subSectionKPIs]);

  const hasMultiSelectCustom = useMemo(
    () =>
      (subSectionKPIs || []).some(
        sskpi => sskpi.unitMeasure?.inputType === 'multiselectcustom',
      ),
    [subSectionKPIs],
  );

  const valueColumnsMinWidthPx = useMemo(() => {
    return (subSection?.columnRows || [])
      .filter(columnRow => !columnRow.isParentColumn)
      .reduce((total, columnRow) => {
        const quantity =
          columnRow.minimumQuantity != null && columnRow.minimumQuantity > 1
            ? columnRow.minimumQuantity
            : 1;
        return (
          total +
          quantity *
            (valueCellMinWidthByColumnRowID[columnRow.columnRowID] ??
              GROUPED_TABLE_VALUE_CELL_MIN_PX)
        );
      }, 0);
  }, [subSection?.columnRows, valueCellMinWidthByColumnRowID]);

  const hasPartialRejection = rejectedKpisList?.length > 0;

  // Same SSKs the partial rejection modal offers (ModuleButtons skips Calculation)
  const rejectableSubSectionKPIs = useMemo(
    () =>
      (subSectionKPIs || []).filter(
        ssk =>
          ssk.subSectionID == subSection.subSectionID &&
          ssk.inputCalc != 'Calculation',
      ),
    [subSectionKPIs, subSection.subSectionID],
  );

  // Every rejectable SSK of every row was reopened: rows can be added (editable) and removed
  const isSubSectionFullyReopened = useMemo(() => {
    if (!isRowOrColumn || !hasPartialRejection || !numberOfRows) return false;
    if (rejectableSubSectionKPIs.length === 0) return false;
    return rejectableSubSectionKPIs.every(ssk =>
      [...Array(numberOfRows)].every((x, row) =>
        rejectedKpisList.some(
          r =>
            r.subSectionKPIID == ssk.subSectionKPIID &&
            r.rowIndex == row &&
            r.columnIndex == null,
        ),
      ),
    );
  }, [
    isRowOrColumn,
    hasPartialRejection,
    numberOfRows,
    rejectableSubSectionKPIs,
    rejectedKpisList,
  ]);

  const canAddOrRemoveRows =
    moduleObject?.isEditable === true &&
    !subSection?.isNotShowAddDeleteButtons &&
    (!hasPartialRejection || isSubSectionFullyReopened);

  const rowHasLinkedContent = row => {
    const rowSskIDs = (subSectionKPIs || [])
      .filter(ssk => ssk.subSectionID == subSection.subSectionID)
      .map(ssk => ssk.subSectionKPIID);
    const isRowSsk = item =>
      rowSskIDs.includes(item.subSectionKPIID) && item.row == row;

    const hasCommentOrFile = (moduleObject.answers || []).some(
      answer =>
        isRowSsk(answer) &&
        ((answer.comment != null && String(answer.comment).trim() !== '') ||
          (Array.isArray(answer.file) && answer.file.some(f => !f.isDeleted))),
    );

    return (
      hasCommentOrFile ||
      (kpiDiscussions || []).some(isRowSsk) ||
      (kpiEvidences || []).some(isRowSsk)
    );
  };

  const tableMinWidthPx = useMemo(() => {
    const n = valueColumnCellCount;
    if (n < 1) return undefined;
    const iconPx = 48;
    const descPx = isColumnOverload ? 252 : 220;
    const unitsPx = 180;
    const deletePx = isRowOrColumn && canAddOrRemoveRows ? 56 : 0;
    return (
      iconPx +
      descPx +
      unitsPx +
      valueColumnsMinWidthPx +
      deletePx
    );
  }, [
    valueColumnCellCount,
    valueColumnsMinWidthPx,
    hasMultiSelectCustom,
    isColumnOverload,
    isRowOrColumn,
    canAddOrRemoveRows,
  ]);

  // Horizontal overflow depends on the rendered controls, not only on the number of ColumnRows.
  // Keep it separate from isColumnOverload, which also controls fixed columns and vertical scroll.
  useLayoutEffect(() => {
    const viewport = tableViewportRef.current;
    const table = tableElementRef.current;

    if (!viewport || !table) return undefined;

    let animationFrameId = null;
    let isDisposed = false;

    const measureOverflow = () => {
      animationFrameId = null;
      if (isDisposed) return;

      const viewportWidth = viewport.clientWidth;
      if (viewportWidth <= 0) return;

      const tableWidth = Math.max(
        table.scrollWidth,
        table.getBoundingClientRect().width,
      );
      const nextHasOverflow = tableWidth - viewportWidth > 1;

      setHasHorizontalOverflow(currentValue =>
        currentValue === nextHasOverflow ? currentValue : nextHasOverflow,
      );
    };

    const scheduleOverflowMeasurement = () => {
      if (isDisposed) return;

      if (animationFrameId != null) {
        window.cancelAnimationFrame(animationFrameId);
      }
      animationFrameId = window.requestAnimationFrame(measureOverflow);
    };

    measureOverflow();

    const ResizeObserverConstructor = window.ResizeObserver;
    const resizeObserver = ResizeObserverConstructor
      ? new ResizeObserverConstructor(scheduleOverflowMeasurement)
      : null;

    if (resizeObserver) {
      resizeObserver.observe(viewport);
      resizeObserver.observe(table);
    } else {
      window.addEventListener('resize', scheduleOverflowMeasurement);
    }

    const MutationObserverConstructor = window.MutationObserver;
    const mutationObserver = MutationObserverConstructor
      ? new MutationObserverConstructor(scheduleOverflowMeasurement)
      : null;

    if (mutationObserver) {
      mutationObserver.observe(table, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    return () => {
      isDisposed = true;
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      window.removeEventListener('resize', scheduleOverflowMeasurement);

      if (animationFrameId != null) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  const addNewLine = subSection => {
    var newNumber = numberOfRows + 1;
    if (isSubSectionFullyReopened) {
      // New row of a fully reopened SubSection is reopened too (the API persists it on save)
      const isRejectedByGlobal = rejectedKpisList.some(
        r =>
          r.isRejectedByGlobal &&
          rejectableSubSectionKPIs.some(
            ssk => ssk.subSectionKPIID == r.subSectionKPIID,
          ),
      );
      setRejectedKpisList([
        ...rejectedKpisList,
        ...rejectableSubSectionKPIs.map(ssk => ({
          subSectionKPIID: ssk.subSectionKPIID,
          rowIndex: numberOfRows,
          columnIndex: null,
          isRejectedByGlobal,
        })),
      ]);
    }
    moduleObject.data.sections.map(section => {
      var currentSubSection = section.subSections.find(
        x => x.subSectionID == subSection.subSectionID,
      );
      if (currentSubSection != null) {
        currentSubSection.numberOfRows = newNumber;
      }
    });
    setNumberOfRows(newNumber);
    setModuleObject({ ...moduleObject });
  };

  const removeLastLine = (subSection, row) => {
    var newList = [];
    if (numberOfRows == 1) {
      Swal.fire({
        title: 'Warning',
        text: 'You must have at least one row in this subsection',
        icon: 'warning',
        showDenyButton: false,
        confirmButtonColor: '#112A61',
        confirmButtonText: 'Ok',
        showCloseButton: true,
      });
    } else if (hasPartialRejection && rowHasLinkedContent(row)) {
      Swal.fire({
        title: 'Warning',
        text: 'This row cannot be removed because it has comments, attachments or discussions.',
        icon: 'warning',
        showDenyButton: false,
        confirmButtonColor: '#112A61',
        confirmButtonText: 'Ok',
        showCloseButton: true,
      });
    } else {
      newList = moduleObject.answers.filter(
        x =>
          x.subSectionID != subSection.subSectionID ||
          (x.subSectionID == subSection.subSectionID && x.row != row),
      );
      Swal.fire({
        title: 'Are you sure you want to remove the line',
        text: 'If you press Yes, the line will be removed and also the data.',
        icon: 'warning',
        showDenyButton: true,
        confirmButtonColor: '#112A61',
        denyButtonColor: '#B0B0BB',
        denyButtonText: 'No',
        confirmButtonText: 'Yes',
        showCloseButton: true,
      }).then(async result => {
        if (result.isConfirmed) {
          var newNumber = numberOfRows - 1;

          var sskList = moduleObject.answers.filter(
            x => x.subSectionID == subSection.subSectionID && x.row == row,
          );
          if (sskList != null && sskList.length > 0) {
            var targetSSK = subSectionKPIs.find(
              x => x.subSectionKPIID == sskList[0].subSectionKPIID,
            );
            var targetColumn = moduleObject.columnRows.find(
              x => x.columnRowID == targetSSK.columnRowID,
            );
            var ssk = subSectionKPIs.find(
              x => x.refNumber == targetColumn.kpiReference,
            );
            //Adicionar validador se coluna refere-se a Fuel OU Country, e chamar update referente
            if (ssk != null && ssk != '') {
              if (COLUMN_ROW_TYPES.Country == targetColumn.type) {
                updateSelectedCountry('', ssk, row, true); //need fixing
              } else if (COLUMN_ROW_TYPES.FuelType == targetColumn.type) {
                updateSelectedFuelType('', ssk, row, true); //need fixing
                updateSelectedCuringBarn('', ssk, row, true);
              } else if (COLUMN_ROW_TYPES.Simple == targetColumn.type) {
                moduleObject.data.sections.map(section => {
                  var currentSubSection = section.subSections.find(
                    x => x.subSectionID == subSection.subSectionID,
                  );
                  if (currentSubSection != null) {
                    currentSubSection.numberOfRows = newNumber;
                  }
                });
              }
            } else if (COLUMN_ROW_TYPES.Simple == targetColumn.type) {
              moduleObject.data.sections.map(section => {
                var currentSubSection = section.subSections.find(
                  x => x.subSectionID == subSection.subSectionID,
                );
                if (currentSubSection != null) {
                  currentSubSection.numberOfRows = newNumber;
                }
              });
            }

            moduleObject.removedAnswers = sskList;
            newList.map(item => {
              if (
                item.row > row &&
                item.subSectionID == subSection.subSectionID
              ) {
                return (item.row = item.row - 1);
              }
            });
            setModuleObject({ ...moduleObject, answers: newList });
          }
          setNumberOfRows(newNumber);
          if (isSubSectionFullyReopened) {
            // Rows below shift up and every row stays reopened, so the last row index is the one that disappears
            const subSectionSskIDs = rejectableSubSectionKPIs.map(
              ssk => ssk.subSectionKPIID,
            );
            setRejectedKpisList(
              rejectedKpisList.filter(
                r =>
                  !(
                    subSectionSskIDs.includes(r.subSectionKPIID) &&
                    r.rowIndex == numberOfRows - 1
                  ),
              ),
            );
          }
        }
      });
    }
  };

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const getSubSectionColorHeader = (subSection, userRoles) => {
    const defaultColor = "#112A61"
    const rolesArray = userRoles.includes("[") ? JSON.parse(userRoles) : userRoles;
    const role = rolesArray[0];
    if (role != null && role != "") {
      if (subSection.subSectionColorHeaderRoles.some(x => x.name === role)) {
        if (role == "RoleApprover" && !subSection.changeColorJustGlobalOrBoth) {
          if (userObject.companyID != null) {
            return subSection.colorHeader;
          }
        }
        else if (role == "RoleApprover" && subSection.changeColorJustGlobalOrBoth) {
          if (userObject.companyID == null) {
            return subSection.colorHeader;
          }
        }
        else {
          return subSection.colorHeader;
        }
      }
    }
    return defaultColor;
  }

  return (
    subSection && (
      <Container
        className={''}
        {...events}
        ref={ref}
      >
        <div className="div-header" style={{ backgroundColor: getSubSectionColorHeader(subSection, userRoles) }}>
          <div className="sub-section-header-row">
            <div
              className="sub-section-description"
            >
              <div>{subSection.description}</div>
            </div>
            <div className="sub-section-header-actions">
              <GuideExternalLink
                url={subSection.guideExternalLink}
                className="sub-section-header-action"
                style={{ marginLeft: 0 }}
              />
              {subSection.documentUploadFolderID != null && (
                <a
                  className="sub-section-header-action"
                  href={`/Documents/${subSection.documentUploadFolderID}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Open document folder"
                  aria-label="Open document folder in a new tab"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FaExternalLinkAlt size={16} aria-hidden="true" />
                </a>
              )}
              {subSection.isCollapse && (
                <button
                  type="button"
                  className="sub-section-header-action"
                  title={collapsed ? 'Expand subsection' : 'Collapse subsection'}
                  aria-label={collapsed ? 'Expand subsection' : 'Collapse subsection'}
                  aria-expanded={!collapsed}
                  onClick={handleToggle}
                >
                  {!collapsed ? (
                    <FaAngleUp
                      className="hover-disable"
                      size={22}
                      aria-hidden="true"
                    />
                  ) : (
                    <FaAngleDown
                      className="hover-disable"
                      size={22}
                      aria-hidden="true"
                    />
                  )}
                </button>
              )}
            </div>
          </div>
          {subSection.guidance != '' && !collapsed && (
            <tr>
              <div
                className="sub-section-guidance"
                colSpan={
                  subSection.columnRows.length > 10
                    ? subSection.columnRows.length
                    : 12
                }
              >
                {subSection.guidance}
              </div>
            </tr>
          )}
        </div>
        <div
          ref={tableViewportRef}
          style={{
            height:
              isColumnOverload && subSection.kpis?.length > 4
                ? '600px'
                : 'auto',
            // Se a altura for auto, overflow visible permite thead sticky no scroll da página.
            // Se for 600px, overflow auto permite scroll interno (regra isColumnOverload).
            overflowY:
              isColumnOverload && subSection.kpis?.length > 4
                ? 'auto'
                : undefined,
            display: collapsed ? 'none' : 'block',
          }}
          className={
            isColumnOverload && subSection.kpis?.length > 4
              ? 'tableFixHead tableFixHead--box-scroll'
              : isColumnOverload || hasMultiSelectCustom
                ? 'tableFixHead tableFixHead--wide'
                : 'tableFixHead'
          }
        >
          <Table
            ref={tableElementRef}
            className="w-100"
            style={
              tableMinWidthPx != null
                ? { minWidth: `${tableMinWidthPx}px`, width: '100%' }
                : { width: '100%' }
            }
          >
            <thead
              className={`primary-header sticky-top ${userObject?.companyID != null ? "info-holder-header" : "header-default"}`}
            >
              <>
                {!isRowOrColumn ? (
                  <>
                    {subSection && (
                      <>
                        <>
                          {subSection.columnRows && (
                            <tr>
                              <th
                                rowSpan={2}
                                width="2%"
                                className={
                                  isColumnOverload ? 'fixed-head fixed-head-icon' : ''
                                }
                              ></th>
                              <th
                                rowSpan={2}
                                width={`${descriptionColumnsWidth}%`}
                                className={
                                  isColumnOverload ? 'fixed-head fixed-head-desc' : ''
                                }
                                style={
                                  isColumnOverload
                                    ? {
                                      minWidth: '250px',
                                      width: '250px',
                                      paddingLeft: '20px',
                                      left: '4%',
                                    }
                                    : {}
                                }
                              >
                                Description
                              </th>
                              <th
                                rowSpan={2}
                                width="5%"
                                className={
                                  isColumnOverload
                                    ? 'text-center fixed-head fixed-head-units'
                                    : 'text-center'
                                }
                                style={
                                  isColumnOverload
                                    ? {
                                        position: 'sticky',
                                        left: '290px',
                                        minWidth: '100px',
                                        zIndex: 100,
                                      }
                                    : {}
                                }
                              >
                                Units
                              </th>
                              <>
                                {reordenateColumns(subSection.columnRows)
                                  .filter(x => x.isParentColumn == false)
                                  .map((childColumn, index) => {
                                    if (childColumn.parentColumnRowID == null) {
                                      if (childColumn.minimumQuantity > 1) {
                                        List.push({
                                          parentName: '',
                                          columnRowOrder: index,
                                          parentColumnRowID:
                                            childColumn.parentColumnRowID,
                                          colSpan: childColumn.minimumQuantity,
                                          index: index,
                                        });
                                      } else {
                                        List.push({
                                          parentName: '',
                                          columnRowOrder: index,
                                          parentColumnRowID:
                                            childColumn.parentColumnRowID,
                                          colSpan: 1,
                                          index: index,
                                        });
                                      }
                                    } else {
                                      var parentExists = List.find(
                                        x =>
                                          x.parentColumnRowID ==
                                          childColumn.parentColumnRowID,
                                      );
                                      var parentCol =
                                        subSection.columnRows.find(
                                          x =>
                                            x.columnRowOrder ==
                                            childColumn.parentColumnRowID,
                                        );
                                      if (!parentExists && parentCol) {
                                        List.push({
                                          parentName: parentCol.name,
                                          parentColumnRowID:
                                            childColumn.parentColumnRowID,
                                          columnRowOrder: index,
                                          colSpan: 1,
                                          index: index,
                                        });
                                      } else {
                                        var parentList = List.filter(
                                          x =>
                                            x.parentColumnRowID !=
                                            childColumn.parentColumnRowID,
                                        );
                                        parentExists.colSpan =
                                          parseInt(parentExists.colSpan) + 1;
                                        parentList.push(parentExists);
                                      }
                                    }
                                  })}
                                {List.some(x => x.parentName != '') &&
                                  reordenateColumns(List).map(
                                    (groupByColumnObject, index) => {
                                      var colSpanToParent =
                                        subSection.columnRows.filter(
                                          x =>
                                            x.parentColumnRowID ==
                                            groupByColumnObject.columnRowOrder,
                                        ).length;

                                      return (
                                        <th
                                          style={{
                                            border: '1px solid #ECECF3',
                                            padding: '1rem',
                                          }}
                                          className="text-center"
                                          colSpan={groupByColumnObject.colSpan}
                                          key={`groupByColumn-${index}`}
                                        >
                                          {groupByColumnObject.parentName}
                                        </th>
                                      );
                                    },
                                  )}
                              </>
                            </tr>
                          )}
                        </>
                        <tr>
                          <>
                            {reordenateColumns(subSection.columnRows)
                              .filter(x => x.isParentColumn == false)
                              .map((columnRow, index) => {
                                if (
                                  columnRow.minimumQuantity != null &&
                                  columnRow.minimumQuantity > 1
                                ) {
                                  return [
                                    ...Array(columnRow.minimumQuantity),
                                  ].map((x, rowI) => {
                                    return (
                                      <th
                                        id={`ColumnRow_${columnRow.columnRowID}_${rowI}`}
                                        style={{
                                          border: '1px solid #ECECF3',
                                          minWidth: GROUPED_TABLE_VALUE_CELL_MIN_PX,
                                        }}
                                        className="text-center"
                                        width="10%"
                                      >
                                        {columnRow.type == 4
                                          ? selectedCultureTypes[rowI]?.text
                                          : columnRow.name +
                                          ' ' +
                                          parseInt(rowI + 1)}
                                      </th>
                                    );
                                  });
                                } else {
                                  return (
                                    <>
                                      <th
                                        id={`columnRowID_${columnRow.columnRowID}`}
                                        style={{
                                          border: '1px solid #ECECF3',
                                          padding: '1rem',
                                          minWidth: GROUPED_TABLE_VALUE_CELL_MIN_PX,
                                        }}
                                        className={'text-center'}
                                        key={`titleOfColumn-${index}`}
                                        width={'10%'}
                                      >
                                        {columnRow.name}
                                      </th>
                                    </>
                                  );
                                }
                              })}
                          </>
                        </tr>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {subSection && (
                      <>
                        {reordenateColumns(subSection.columnRows)
                          .filter(x => x.isParentColumn == false)
                          .map((childColumn, index) => {
                            if (childColumn.parentColumnRowID == null) {
                              if (childColumn.minimumQuantity > 1) {
                                List.push({
                                  parentName: '',
                                  columnRowOrder: 1,
                                  parentColumnRowID:
                                    childColumn.parentColumnRowID,
                                  colSpan: childColumn.minimumQuantity,
                                  index: index,
                                });
                              } else {
                                List.push({
                                  parentName: '',
                                  columnRowOrder: index,
                                  parentColumnRowID:
                                    childColumn.parentColumnRowID,
                                  colSpan: 1,
                                  index: index,
                                });
                              }
                            } else {
                              var parentExists = List.find(
                                x =>
                                  x.parentColumnRowID ==
                                  childColumn.parentColumnRowID,
                              );
                              var parentCol = subSection.columnRows.find(
                                x =>
                                  x.columnRowOrder ==
                                  childColumn.parentColumnRowID,
                              );
                              if (!parentExists && parentCol) {
                                List.push({
                                  parentName: parentCol.name,
                                  parentColumnRowID:
                                    childColumn.parentColumnRowID,
                                  columnRowOrder: index,
                                  colSpan: 1,
                                  index: index,
                                });
                              } else {
                                var parentList = List.filter(
                                  x =>
                                    x.parentColumnRowID !=
                                    childColumn.parentColumnRowID,
                                );
                                parentExists.colSpan =
                                  parseInt(parentExists.colSpan) + 1;
                                parentList.push(parentExists);
                              }
                            }
                          })}
                        {List.some(x => x.parentName != '') && (
                          <tr>
                            <th rowSpan={2} width="2%"></th>
                            {reordenateColumns(List).map(
                              (groupByColumnObject, index) => {
                                var colSpanToParent =
                                  subSection.columnRows.filter(
                                    x =>
                                      x.parentColumnRowID ==
                                      groupByColumnObject.columnRowOrder,
                                  ).length;

                                return (
                                  <th
                                    style={{
                                      border: '1px solid #ECECF3',
                                      padding: '1rem',
                                    }}
                                    className="text-center"
                                    colSpan={groupByColumnObject.colSpan}
                                    key={`groupByColumn-${index}`}
                                  >
                                    {groupByColumnObject.parentName}
                                  </th>
                                );
                              },
                            )}
                            {moduleObject.isEditable == true &&
                              subSection.numberOfRows > 0 && (
                                <th key={`KPIColumnRow_del`} width={'2%'}></th>
                              )}
                          </tr>
                        )}
                        <tr>
                          {subSection.columnRows.filter(
                            x => x.isParentColumn == false && x.type != 2
                          ).length > 0 && subSection.columnRows.filter(x => x.isParentColumn == true).length == 0 && <th rowSpan={2} width="2%"></th>}
                          <>
                            {reordenateColumns(subSection.columnRows)
                              .filter(x => x.isParentColumn == false)
                              .map((columnRow, index) => {
                                const headerSsk = subSection.kpis[0]?.subSectionKPIs?.find(
                                  x => x.columnRowID == columnRow.columnRowID,
                                );
                                return (
                                  <>
                                    <th
                                      style={{
                                        fontSize: '12px',
                                        minWidth: GROUPED_TABLE_VALUE_CELL_MIN_PX,
                                      }}
                                      className="text-center"
                                      width={getRowModeValueTdWidthStyle(
                                        headerSsk,
                                        subSectionKPIs,
                                        rowModeHeaderValueLayout,
                                      )}
                                      key={`groupByColumn-${index}`}
                                    >
                                      {columnRow.name}
                                    </th>
                                  </>
                                );
                              })}
                            {moduleObject.isEditable == true &&
                              subSection.numberOfRows > 0 && (
                                <th key={`KPIColumnRow_del`} width={'1%'}></th>
                              )}
                          </>
                        </tr>
                      </>
                    )}
                  </>
                )}
              </>
            </thead>
            <tbody>
              {!isRowOrColumn ? (
                <>
                  {subSection.kpis &&
                    subSection.kpis.map((kpi, index) => {
                      return (
                        <ColumnSimpleGrouped
                          calculations={calculations}
                          subSectionGroupColumnInfo={subSectionGroupColumnInfo}
                          moduleObject={moduleObjectForColumnLayout}
                          formatValuesInTooltip={formatValuesInTooltip}
                          setNumber={setNumber}
                          setText={setText}
                          funcCollapse={funcCollapse}
                          setComment={setComment}
                          uploadFile={uploadFile}
                          getFile={getFile}
                          numberOfRows={numberOfRows}
                          userRoles={userRoles}
                          showDescriptionColumn={showDescriptionColumn}
                          showUnitColumn={showUnitColumn}
                          showSecondaryUnitsColumn={showSecondaryUnitsColumn}
                          collapse={collapse}
                          collapseText={collapseText}
                          collapseCol={collapseCol}
                          row={index}
                          blockedField={blockedField}
                          addNewLine={addNewLine}
                          removeLastLine={removeLastLine}
                          MODULE_ID={MODULE_ID}
                          setChatRequest={setChatRequest}
                          setShowChat={setShowChat}
                          defaultChatRequest={defaultChatRequest}
                          chatRequest={{ ...chatRequest }}
                          kpiDiscussions={kpiDiscussions}
                          kpiEvidences={kpiEvidences}
                          setKPIEvidences={setKPIEvidences}
                          cultureTypeID={cultureTypeID}
                          subSectionKPIsToBlock={subSectionKPIsToBlock}
                          loading={loading}
                          kpi={kpi}
                          totalColumns={totalColumns}
                          tableColumnOverload={isColumnOverload}
                          descriptionColumnsWidth={descriptionColumnsWidth}
                          setModuleObject={setModuleObject}
                          toleranceValidations={toleranceValidations}
                          subSectionKPIs={subSectionKPIs}
                          changeSelectedCultureType={changeSelectedCultureType}
                          selectedCultureTypes={selectedCultureTypes}
                          changeSelectedCountry={changeSelectedCountry}
                          selectedCountries={selectedCountries}
                          changeSelectedFuelType={changeSelectedFuelType}
                          selectedFuelTypes={selectedFuelTypes}
                          columnRows={subSection.columnRows}
                          reordenateColumns={reordenateColumns}
                          loadRefNumbersAndCalculations={
                            loadRefNumbersAndCalculations
                          }
                          rejectedKpisList={rejectedKpisList}
                          defaultValues={defaultValues}
                          fixedKpisList={fixedKpisList}
                          subSectionID={subSection.subSectionID}
                          defaultEvidenceRequest={defaultEvidenceRequest}
                          evidenceRequest={{ ...evidenceRequest }}
                          setEvidenceRequest={setEvidenceRequest}
                          setShowUploadEvidence={setShowUploadEvidence}
                          setSubsectionKPIs={setSubsectionKPIs}
                          valueCellMinWidthPx={GROUPED_TABLE_VALUE_CELL_MIN_PX}
                          valueCellMinWidthByColumnRowID={valueCellMinWidthByColumnRowID}
                        />
                      );
                    })}
                </>
              ) : (
                <>
                  {/* add uma variavel de controle para o numero de row para serem renderizadas */}
                  {[...Array(numberOfRows)].map((x, row) => {
                    return (
                      <>
                        <tr
                          key={`KPI_${subSection.subSectionID}_r${row}`}
                          className={`row-${row}`}
                        >
                          <td width={'2%'}>
                            <TooltipComponent
                              style={{
                                backgroundColor: subSection?.kpis[0]?.guidance
                                  ? '#112A61'
                                  : '#e2e2e2',
                              }}
                              guidance={subSection?.kpis[0]?.guidance}
                              size={14}
                            />
                          </td>
                          {subSection.kpis ? (
                            subSection.kpis.map((kpi, index) => {
                              return (
                                <RowSimpleGrouped
                                  calculations={calculations}
                                  moduleObject={moduleObjectForColumnLayout}
                                  formatValuesInTooltip={formatValuesInTooltip}
                                  setNumber={setNumber}
                                  setText={setText}
                                  funcCollapse={funcCollapse}
                                  setComment={setComment}
                                  uploadFile={uploadFile}
                                  getFile={getFile}
                                  numberOfRows={numberOfRows}
                                  userRoles={userRoles}
                                  showDescriptionColumn={showDescriptionColumn}
                                  showUnitColumn={showUnitColumn}
                                  showSecondaryUnitsColumn={
                                    showSecondaryUnitsColumn
                                  }
                                  collapse={collapse}
                                  collapseText={collapseText}
                                  collapseRow={collapseRow}
                                  row={row}
                                  blockedField={blockedField}
                                  addNewLine={addNewLine}
                                  removeLastLine={removeLastLine}
                                  MODULE_ID={MODULE_ID}
                                  setChatRequest={setChatRequest}
                                  setShowChat={setShowChat}
                                  chatRequest={{ ...chatRequest }}
                                  kpiDiscussions={kpiDiscussions}
                                  cultureTypeID={cultureTypeID}
                                  subSectionKPIsToBlock={subSectionKPIsToBlock}
                                  loading={loading}
                                  kpi={kpi}
                                  setModuleObject={setModuleObject}
                                  toleranceValidations={toleranceValidations}
                                  subSectionKPIs={subSectionKPIs}
                                  changeSelectedCultureType={
                                    changeSelectedCultureType
                                  }
                                  selectedCultureTypes={selectedCultureTypes}
                                  changeSelectedCountry={changeSelectedCountry}
                                  selectedCountries={selectedCountries}
                                  changeSelectedFuelType={
                                    changeSelectedFuelType
                                  }
                                  changeSelectedCultureTypeRow={changeSelectedCultureTypeRow}
                                  selectedFuelTypes={selectedFuelTypes}
                                  selectedCultureTypesRow={selectedCultureTypesRow}
                                  changeSelectedCuringBarn={
                                    changeSelectedCuringBarn
                                  }
                                  selectedCuringBarns={selectedCuringBarns}
                                  columnRows={subSection.columnRows}
                                  reordenateColumns={reordenateColumns}
                                  setSelectedSSK={setSelectedSSK}
                                  loadRefNumbersAndCalculations={
                                    loadRefNumbersAndCalculations
                                  }
                                  rejectedKpisList={rejectedKpisList}
                                  fixedKpisList={fixedKpisList}
                                  valueColumnsWidth={valueColumnsWidth}
                                  valueCellMinWidthPx={GROUPED_TABLE_VALUE_CELL_MIN_PX}
                                />
                              );
                            })
                          ) : (
                            <></>
                          )}
                          {canAddOrRemoveRows ? (
                            <>
                              <td key={`KPIColumnRow_del`}>
                                <div className={'col-1'} style={{ padding: 0 }}>
                                  <AiOutlineDelete
                                    size={20}
                                    onClick={e =>
                                      removeLastLine(subSection, row)
                                    }
                                  />
                                </div>
                              </td>
                            </>
                          ) : (
                            <></>
                          )}
                        </tr>
                        {selectedSSK &&
                          [...Array(1)].map(x => {
                            var unitMeasure = GetTypeInput(
                              selectedSSK.unitMeasureID,
                              selectedSSK.unitMeasure.type,
                            );
                            var isNumber =
                              selectedSSK.unitMeasure.inputType == 'number' ||
                                selectedSSK.unitMeasure.inputType == 'decimal'
                                ? true
                                : false;
                            var op = `subSectionKPI_${selectedSSK.subSectionKPIID}_${selectedSSK.columnRowID}_r${row}`;

                            var findValue = null;
                            var file = undefined;
                            var comment = '';
                            var value = null;
                            var country = null;
                            var disabledField = false;
                            var isFromFSMIntegration = null;
                            var targetColumn = moduleObject.columnRows.find(
                              x => x.columnRowID == selectedSSK.columnRowID,
                            );

                            var nonParentColsForEvidence = reordenateColumns(
                              subSection.columnRows,
                            ).filter(x => x.isParentColumn == false);
                            var evidenceColumnIndex = nonParentColsForEvidence.findIndex(
                              x => x.columnRowID == selectedSSK.columnRowID,
                            );
                            var evidenceColumnForApi =
                              nonParentColsForEvidence.length > 1 &&
                              evidenceColumnIndex >= 0
                                ? evidenceColumnIndex
                                : null;

                            // Match RowSimpleGrouped: only filter by row when there is more than one row
                            // (single-row subsections often store answers with row null; requiring row === 0 broke findValue)
                            if (numberOfRows > 1) {
                              findValue = moduleObject.answers.find(
                                x =>
                                  x.subSectionKPIID ==
                                    selectedSSK.subSectionKPIID &&
                                  x.refNumber == selectedSSK.refNumber &&
                                  x.row == row &&
                                  x.subSectionID == selectedSSK.subSectionID,
                              );
                            } else {
                              findValue = moduleObject.answers.find(
                                x =>
                                  x.subSectionKPIID ==
                                    selectedSSK.subSectionKPIID &&
                                  x.refNumber == selectedSSK.refNumber,
                              );
                            }
                            if (findValue != undefined && findValue != null) {
                              file = findValue.file;
                              comment = findValue.comment ?? '';
                              value = isNumber
                                ? findValue.numberValue
                                : findValue.textValue;
                            }

                            var sskEvidence = kpiEvidences.find(x => {
                              if (
                                x.subSectionKPIID != selectedSSK.subSectionKPIID ||
                                x.row != row
                              )
                                return false;
                              if (evidenceColumnForApi == null)
                                return (
                                  x.column == null || x.column === undefined
                                );
                              return x.column === evidenceColumnForApi;
                            });

                            return (
                              <Collapse
                                in={
                                  collapse == selectedSSK.subSectionKPIID &&
                                  collapseRow == row
                                }
                                unmountOnExit={true}
                              >
                                <tr
                                  style={{
                                    verticalAlign: 'top',
                                    backgroundColor: 'rgb(250 250 250)',
                                  }}
                                >
                                  <td
                                    colSpan={totalColumns + 3}
                                    style={{ textAlign: 'left', padding: 25 }}
                                  >
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <p>
                                          Comment{' '}
                                          {selectedSSK.comment ==
                                            'Mandatory' && (
                                              <span className="required-kpi">
                                                *
                                              </span>
                                            )}
                                        </p>
                                        <CommentTextArea
                                          key={`${op}_${findValue?.thriveValueID ?? 'na'}_${findValue?.numberValue ?? ''}_${findValue?.textValue ?? ''}_${findValue?.comment ?? ''}`}
                                          name={op + '_commentText'}
                                          id={op + '_commentText'}
                                          rows="5"
                                          style={{
                                            margin: 0,
                                            width: '100%',
                                            backgroundColor: '#fff',
                                          }}
                                          defaultValue={comment}
                                          disabled={
                                            moduleObject.isEditable &&
                                              findValue != undefined &&
                                              findValue != null
                                              ? false
                                              : true
                                          }
                                          className={
                                            moduleObject.isEditable
                                              ? ''
                                              : 'block-comment'
                                          }
                                          onBlur={e =>
                                            setComment({
                                              subSectionKPI: selectedSSK,
                                              ref: selectedSSK.refNumber,
                                              value: e.target.value,
                                              row: row,
                                              moduleObject: moduleObject,
                                              setModuleObject: setModuleObject,
                                              subSectionKPIs: subSectionKPIs,
                                            })
                                          }
                                        ></CommentTextArea>
                                      </div>

                                      <div className="col-lg-2">
                                        <ChatButton
                                          kpiDiscussions={kpiDiscussions}
                                          setChatRequest={setChatRequest}
                                          setShowChat={setShowChat}
                                          request={{
                                            ...defaultChatRequest,
                                            subSectionKPIID:
                                              selectedSSK.subSectionKPIID,
                                            kpiId: selectedSSK.kpiid,
                                            row: row,
                                            fuelTypeId:
                                              COLUMN_ROW_TYPES.FuelType ==
                                                targetColumn.type
                                                ? selectedFuelTypes.find(
                                                  x =>
                                                    x.index == row &&
                                                    x.subSectionID ==
                                                    selectedSSK.subSectionID,
                                                )?.value
                                                : null,
                                            cultureTypeID:
                                              COLUMN_ROW_TYPES.FuelType ==
                                                targetColumn.type &&
                                                selectedSSK.refNumber == '8506'
                                                ? selectedCultureTypesRow.find(
                                                  x =>
                                                    x.index == row &&
                                                    x.subSectionID ==
                                                    selectedSSK.subSectionID,
                                                )?.value
                                                :
                                                COLUMN_ROW_TYPES.CultureType ==
                                                  targetColumn.type &&
                                                  selectedSSK.refNumber == '8505'
                                                  ? selectedCultureTypesRow.find(
                                                    x =>
                                                      x.index == row &&
                                                      x.subSectionID ==
                                                      selectedSSK.subSectionID,
                                                  )?.value
                                                  : null,
                                            curingBarnID:
                                              COLUMN_ROW_TYPES.FuelType ==
                                                targetColumn.type &&
                                                selectedSSK.refNumber == '8215'
                                                ? selectedCuringBarns.find(
                                                  x =>
                                                    x.index == row &&
                                                    x.subSectionID ==
                                                    selectedSSK.subSectionID,
                                                )?.value
                                                : null,
                                            countryId:
                                              COLUMN_ROW_TYPES.Country ==
                                                targetColumn.type
                                                ? selectedCountries[row]?.value
                                                : null,

                                          }}
                                        />
                                        {selectedSSK.evidence == 'Mandatory' && (
                                        <EvidenceButton
                                          kpiEvidences={kpiEvidences}
                                          setEvidenceRequest={
                                            setEvidenceRequest
                                          }
                                          setShowUploadEvidence={
                                            setShowUploadEvidence
                                          }
                                          isMandatory
                                          moduleObject={moduleObject}
                                          evidenceRequest={{
                                            ...defaultEvidenceRequest,
                                            evidenceRefValidateValue:
                                              getLiveEvidenceRefValidateValue(
                                                {
                                                  moduleObject,
                                                  subSectionKPIs,
                                                  evidenceSubSectionKPI:
                                                    selectedSSK,
                                                  row,
                                                  numberOfRows,
                                                  columnRows:
                                                    subSection.columnRows,
                                                  reordenateColumns,
                                                  evidenceColumn:
                                                    evidenceColumnForApi,
                                                  evidenceCultureTypeID:
                                                    (COLUMN_ROW_TYPES.FuelType ==
                                                      targetColumn.type &&
                                                    selectedSSK.refNumber ==
                                                      '8506'
                                                      ? selectedCultureTypesRow.find(
                                                          x =>
                                                            x.index ==
                                                              row &&
                                                            x.subSectionID ==
                                                              selectedSSK.subSectionID,
                                                        )?.value
                                                      : COLUMN_ROW_TYPES.CultureType ==
                                                          targetColumn.type &&
                                                          selectedSSK.refNumber ==
                                                            '8505'
                                                        ? selectedCultureTypesRow.find(
                                                            x =>
                                                              x.index ==
                                                                row &&
                                                              x.subSectionID ==
                                                                selectedSSK.subSectionID,
                                                          )?.value
                                                        : null) ??
                                                    cultureTypeID,
                                                },
                                              ),
                                            subSectionKPIID:
                                              selectedSSK.subSectionKPIID,
                                            row: row,
                                            column: evidenceColumnForApi,
                                            fuelTypeId:
                                              COLUMN_ROW_TYPES.FuelType ==
                                                targetColumn.type
                                                ? selectedFuelTypes.find(
                                                  x =>
                                                    x.index == row &&
                                                    x.subSectionID ==
                                                    selectedSSK.subSectionID,
                                                )?.value
                                                : null,
                                            cultureTypeID:
                                              COLUMN_ROW_TYPES.FuelType ==
                                                targetColumn.type &&
                                                selectedSSK.refNumber == '8506'
                                                ? selectedCultureTypesRow.find(
                                                  x =>
                                                    x.index == row &&
                                                    x.subSectionID ==
                                                    selectedSSK.subSectionID,
                                                )?.value
                                                :
                                                COLUMN_ROW_TYPES.CultureType ==
                                                  targetColumn.type &&
                                                  selectedSSK.refNumber == '8505'
                                                  ? selectedCultureTypesRow.find(
                                                    x =>
                                                      x.index == row &&
                                                      x.subSectionID ==
                                                      selectedSSK.subSectionID,
                                                  )?.value
                                                  : cultureTypeID != null &&
                                                    cultureTypeID !== ''
                                                  ? Number(cultureTypeID)
                                                  : null,
                                            curingBarnID:
                                              COLUMN_ROW_TYPES.FuelType ==
                                                targetColumn.type
                                                ? selectedCuringBarns.find(
                                                  x =>
                                                    x.index == row &&
                                                    x.subSectionID ==
                                                    selectedSSK.subSectionID,
                                                )?.value
                                                : null,
                                            countryId:
                                              COLUMN_ROW_TYPES.Country ==
                                                targetColumn.type
                                                ? selectedCountries[row]?.value
                                                : null,
                                            subSectionKPIValue: value ?? 0,
                                            file: sskEvidence?.file,
                                            value: sskEvidence?.value,
                                            farmersCount:
                                              sskEvidence?.farmersCount,
                                            isValidated:
                                              sskEvidence?.isValidated,
                                          }}
                                        />
                                        )}
                                      </div>
                                      <div className="col-lg-4">
                                        <p>Files {(selectedSSK.mandatoryAttachment && (value == null || value === '' || Number(value) !== 0)) && (
                                          <span className="required-kpi">*</span>
                                        )} </p>
                                        {moduleObject.isEditable &&
                                          userRoles.includes(
                                            'RoleInfoHolder',
                                          ) && (
                                            <>
                                              <div className="upload-btn-wrapper">
                                                <button
                                                  id={op + '_file'}
                                                  className="btn-custom"
                                                  disabled={
                                                    findValue != undefined &&
                                                      findValue != null
                                                      ? false
                                                      : true
                                                  }
                                                >
                                                  Upload a file (need to save
                                                  the form)
                                                </button>
                                                <input
                                                  type="file"
                                                  disabled={
                                                    findValue != undefined &&
                                                      findValue != null
                                                      ? false
                                                      : true
                                                  }
                                                  multiple
                                                  onChange={files => {
                                                    uploadFile({
                                                      subSectionKPI:
                                                        selectedSSK,
                                                      ref: selectedSSK.refNumber,
                                                      files: files,
                                                      row: row,
                                                      moduleObject:
                                                        moduleObject,
                                                      setModuleObject:
                                                        setModuleObject,
                                                      selectedCultureTypes:
                                                        selectedCultureTypes,
                                                      subSectionKPIs:
                                                        subSectionKPIs,
                                                    });
                                                  }}
                                                />
                                              </div>
                                              <br />
                                            </>
                                          )}
                                        {file != '' &&
                                          file != null &&
                                          file.length > 0 &&
                                          file.filter(e => !e.isDeleted).length >
                                          0 ? (
                                          Array.isArray(file) ? (
                                            file
                                              .filter(e => !e.isDeleted)
                                              .map(e => {
                                                return (
                                                  <>
                                                    {e.file
                                                      .toLowerCase()
                                                      .includes('docx') ? (
                                                      <AiFillFileWord
                                                        style={{
                                                          marginLeft: 20,
                                                        }}
                                                        title={e.file}
                                                        size={25}
                                                        onClick={() =>
                                                          getFile(e.file)
                                                        }
                                                      ></AiFillFileWord>
                                                    ) : e.file
                                                      .toLowerCase()
                                                      .includes('pdf') ? (
                                                      <AiFillFilePdf
                                                        style={{
                                                          marginLeft: 20,
                                                        }}
                                                        title={e.file}
                                                        size={25}
                                                        onClick={() =>
                                                          getFile(e.file)
                                                        }
                                                      ></AiFillFilePdf>
                                                    ) : e.file
                                                      .toLowerCase()
                                                      .includes('png') ||
                                                      e.file
                                                        .toLowerCase()
                                                        .includes('jpg') ||
                                                      e.file
                                                        .toLowerCase()
                                                        .includes('jfif') ? (
                                                      <AiFillFileImage
                                                        style={{
                                                          marginLeft: 20,
                                                        }}
                                                        title={e.file}
                                                        size={25}
                                                        onClick={() =>
                                                          getFile(e.file)
                                                        }
                                                      ></AiFillFileImage>
                                                    ) : e.file
                                                      .toLowerCase()
                                                      .includes('xlsx') ? (
                                                      <AiFillFileExcel
                                                        style={{
                                                          marginLeft: 20,
                                                        }}
                                                        title={e.file}
                                                        size={25}
                                                        onClick={() =>
                                                          getFile(e.file)
                                                        }
                                                      ></AiFillFileExcel>
                                                    ) : (
                                                      <FaFileAlt
                                                        style={{
                                                          marginLeft: 20,
                                                        }}
                                                        title={e.file}
                                                        size={25}
                                                        onClick={() =>
                                                          getFile(e.file)
                                                        }
                                                      ></FaFileAlt>
                                                    )}
                                                    {userRoles.includes(
                                                      'RoleInfoHolder',
                                                    ) &&
                                                      moduleObject.isEditable && (
                                                        <AiFillCloseCircle
                                                          className="delete-button"
                                                          size={15}
                                                          onClick={() => {
                                                            removeFile({
                                                              subSectionKPI:
                                                                selectedSSK,
                                                              ref: selectedSSK.refNumber,
                                                              value: e.file,
                                                              row: row,
                                                              moduleObject:
                                                                moduleObject,
                                                              setModuleObject:
                                                                setModuleObject,
                                                              selectedCultureTypes:
                                                                selectedCultureTypes,
                                                              subSectionKPIs:
                                                                subSectionKPIs,
                                                              deleteFile: true,
                                                            });
                                                          }}
                                                        ></AiFillCloseCircle>
                                                      )}
                                                  </>
                                                );
                                              })
                                          ) : (
                                            file
                                          )
                                        ) : (
                                          <>No file attached</>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </Collapse>
                            );
                          })}
                      </>
                    );
                  })}
                  {subSection.maxRowsQuantity > 0 &&
                    numberOfRows >= subSection.maxRowsQuantity ? (
                    <></>
                  ) : canAddOrRemoveRows ? (
                    <>
                      <tr width="100%">
                        <td colSpan={4} style={{ padding: '1rem' }}>
                          <a
                            style={{
                              backgroundColor: '#50AF47',
                              padding: '0.5rem 1rem',
                              borderRadius: '3px',
                              color: '#FFF',
                              cursor: 'pointer',
                            }}
                            onClick={() => addNewLine(subSection)}
                          >
                            Add +
                          </a>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </tbody>
          </Table>
        </div>
      </Container>
    )
  );
};

export default GroupedByColumnRowTable;
